<template>
  <div class="rain grid">
    <font-awesome-icon :icon="icon" class="icon" />
    <div class="rain__downfall current">
      
      <span class="primary">{{ rain }}</span>
      <span class="unit">mm</span>
    </div>
    <div class="rain__history extra">
      <span class="detail">{{ rainDay }}mm siste døgnet</span>
    </div>
  </div>
</template>

<script>
export default {
name: 'rain',

props: {
  rain: {
    type: Number
  },
  
  rainDay: {
    type: Number
  }
},

computed: {
  icon(){
    return this.rain >= 1 ? 'cloud-rain' : 'cloud'
  }
}
}
</script>

<style lang="sass">

.rain 

  &__downfall
    
    svg
      margin-bottom: 3px 
      margin-right: 8px

</style>